module.exports = __webpack_public_path__ + "img/2.465b691b.png";